const DispenseType = {
  Vehicle: "vehicle",
  DrumContainer: "drum-container",
};

export default DispenseType;
